const DINO_ASSISTANT_STATES = [
    "idle",
    "listening",
    "thinking",
    "speaking-1",
    "speaking-2",
    "speaking-3",
    "explaining",
    "hint",
    "happy",
    "celebrating",
    "confused",
    "oops",
    "surprised",
    "wink",
    "vision",
    "quiz",
    "success",
    "error",
    "reading",
    "sleeping",
    "walking"
] as const;

type DinoAssistantState = (typeof DINO_ASSISTANT_STATES)[number];

const DINO_ASSISTANT_UI_ACTIONS = [
    "explain",
    "hint",
    "wrong",
    "simpler",
    "translate",
    "quiz",
    "read",
    "microphone",
    "camera",
    "speaker",
    "check",
    "stop",
    "pause",
    "play",
    "context",
    "privacy",
    "local",
    "planned",
    "word"
] as const;

type DinoAssistantUiAction = (typeof DINO_ASSISTANT_UI_ACTIONS)[number];

const mascotStateUrl = (state: DinoAssistantState) =>
    new URL(`./mascot/states/dino-${state}.svg`, import.meta.url).href;

const uiIconUrl = (action: DinoAssistantUiAction) =>
    new URL(`./ui/${action}.svg`, import.meta.url).href;

const dinoAssistantStateAssets = Object.freeze(
    Object.fromEntries(
        DINO_ASSISTANT_STATES.map((state) => [state, mascotStateUrl(state)])
    ) as Record<DinoAssistantState, string>
);

const dinoAssistantUiIconAssets = Object.freeze(
    Object.fromEntries(
        DINO_ASSISTANT_UI_ACTIONS.map((action) => [action, uiIconUrl(action)])
    ) as Record<DinoAssistantUiAction, string>
);

const DINO_SPEAKING_FRAMES = [
    "speaking-1",
    "speaking-2",
    "speaking-3"
] as const satisfies readonly DinoAssistantState[];

const DEFAULT_DINO_ASSISTANT_STATE = "idle" as const satisfies DinoAssistantState;

export {
    DEFAULT_DINO_ASSISTANT_STATE,
    DINO_ASSISTANT_STATES,
    DINO_ASSISTANT_UI_ACTIONS,
    DINO_SPEAKING_FRAMES,
    dinoAssistantStateAssets,
    dinoAssistantUiIconAssets
};

export type {
    DinoAssistantState,
    DinoAssistantUiAction
};
